import type { BlockDirectionType, IBlockInfo, ILayerProps, ISize } from '@/version-types';
import LayerBlock from './layer-block';

class BlockList {
    private data: Map<string, LayerBlock>;

    constructor() {
        this.data = new Map();
    }

    push(layer: ILayerProps, layers: ILayerProps[], activeLayer: ILayerProps, container: ISize) {
        const block = new LayerBlock(layer.id).collectBlocks(layer, layers, activeLayer, container);
        this.data.set(block.id, block);
    }

    getBlocks(id: string, spacing: number, direction: BlockDirectionType) {
        const res: IBlockInfo[] = [];
        const collectInfo = (id: string) => {
            const info = this.data.get(id);
            if (!info) return;
            const blocks = info.getBlocksWithSpacing(spacing, direction);
            if (!blocks) return;
            res.push(...blocks);
            blocks.forEach((item) => {
                collectInfo(item.id);
            });
        };
        collectInfo(id);
        return res;
    }

    forEach(callback: (item: LayerBlock) => void) {
        this.data.forEach((val) => {
            callback(val);
        });
    }
}

export default BlockList;
